var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-data-table',{attrs:{"no-data-text":"اطلاعاتی موجود نیست","item-class":_vm.itemRowColor,"headers":_vm.headers,"items":_vm.data,"disable-pagination":"","hide-default-footer":true,"fixed-header":"","item-key":"key"}})
}
var staticRenderFns = []

export { render, staticRenderFns }